import { render, staticRenderFns } from "./noResult.vue?vue&type=template&id=09971e8d&scoped=true&"
import script from "./noResult.vue?vue&type=script&lang=js&"
export * from "./noResult.vue?vue&type=script&lang=js&"
import style0 from "./noResult.vue?vue&type=style&index=0&id=09971e8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09971e8d",
  null
  
)

export default component.exports